import styled from "styled-components";

export default styled.main`
  flex-grow: 1;
`;
